<script>
    import { createGame } from '@/api/games.js';

    export default {
        computed: {
            isSave() {return this.$store.getters.IS_SAVE_PAG_GAME_ADD}
        },
        methods: {
            async create() {
                const response = await createGame(
                    this.$store.getters.PAG_GAME_ADD
                );
                if (response != null) {
                    this.$store.commit('GAME_PUSH', response);
                    response['have_new_files'] = false;
                    response['released_files_count'] = 0;
                    response['total_files_count'] = 0;
                    this.$store.commit('PAG_GAME_PUSH', {
                        providerID: response.provider_id,
                        payload: response,
                    });
                    this.$store.commit('IS_SHOW_PAG_GAME_ADD', false);
                }
            },
            async close() {
                this.$store.commit('IS_SHOW_PAG_GAME_ADD', false);
            }
        }
    }
</script>


<template>
    <div>
        <button
            :disabled="isSave === false"
            class="button_blue_100"
            @click="create"
        >Create</button>
        <button
            class="button_blue_100 close_button mr_10"
            @click="close"
        >Close</button>
    </div>
</template>